// lodashFunctions.ts

import { LodashOption } from "./types";

export const lodashFunctionsList: LodashOption[] = [
  {
    value: "get",
    label: "get",
    description:
      "_.get(object, path, [defaultValue])\nAccède à la valeur d'une propriété imbriquée.",
  },
  {
    value: "find",
    label: "find",
    description:
      "_.find(collection, [predicate=_.identity], [fromIndex=0])\nTrouve le premier élément dans la collection qui satisfait le prédicat.",
  },
  {
    value: "size",
    label: "size",
    description: "_.size(collection)\nObtient la taille d'une collection.",
  },
  {
    value: "replace",
    label: "replace",
    description:
      "_.replace(string, pattern, replacement)\nRemplace les correspondances dans une chaîne.",
  },
  {
    value: "regex",
    label: "regex",
    description:
      "/!\\ fonction custom qui n'est pas lodash - regex(pattern)\nVérifie si une chaîne correspond à un motif. ",
  },
  {
    value: "truncate",
    label: "truncate",
    description:
      "_.truncate([string=''], [options])\nTronque une chaîne à une longueur donnée.",
  },
  {
    value: "trim",
    label: "trim",
    description:
      "_.trim([string=''], [chars=whitespace])\nSupprime les espaces ou caractères spécifiés au début et à la fin d'une chaîne.",
  },
  {
    value: "toUpper",
    label: "toUpper",
    description: "_.toUpper([string=''])\nConvertit une chaîne en majuscules.",
  },
  {
    value: "toLower",
    label: "toLower",
    description: "_.toLower([string=''])\nConvertit une chaîne en minuscules.",
  },
  {
    value: "toInteger",
    label: "toInteger",
    description: "_.toInteger(value)\nConvertit une valeur en entier.",
  },
  {
    value: "toNumber",
    label: "toNumber",
    description: "_.toNumber(value)\nConvertit une valeur en nombre.",
  },
  {
    value: "map",
    label: "map",
    description:
      "_.map(collection, [iteratee=_.identity])\nMap chaque élément de la collection en appliquant l'itérateur.",
  },
  {
    value: "filter",
    label: "filter",
    description:
      "_.filter(collection, [predicate=_.identity])\nFiltre les éléments de la collection qui satisfont le prédicat.",
  },
  {
    value: "reduce",
    label: "reduce",
    description:
      "_.reduce(collection, [iteratee=_.identity], [accumulator])\nRéduit la collection à une seule valeur en appliquant l'itérateur.",
  },
  {
    value: "capitalize",
    label: "capitalize",
    description:
      "_.capitalize([string=''])\nCapitalise la première lettre d'une chaîne.",
  },
  {
    value: "deburr",
    label: "deburr",
    description:
      "_.deburr([string=''])\nEnlève les accents et diacritiques d'une chaîne.",
  },
  {
    value: "escape",
    label: "escape",
    description:
      "_.escape([string=''])\nÉchappe les caractères HTML dans une chaîne.",
  },
  {
    value: "unescape",
    label: "unescape",
    description:
      "_.unescape([string=''])\nDéséchappe les caractères HTML dans une chaîne.",
  },
  {
    value: "join",
    label: "join",
    description:
      "_.join(array, [separator=','])\nJoint tous les éléments d'un tableau en une chaîne de caractères.",
  },
  {
    value: "split",
    label: "split",
    description:
      "_.split(string, separator, [limit])\nDivise une chaîne en un tableau de sous-chaînes en utilisant le séparateur spécifié.",
  },
  {
    value: "last",
    label: "last",
    description: "_.last(array)\nObtient le dernier élément d'un tableau.",
  },
  {
    value: "nth",
    label: "nth",
    description:
      "_.nth(array, [n=0])\nObtient l'élément à la position n dans un tableau.",
  },
  {
    value: "compact",
    label: "compact",
    description:
      "_.compact(array)\nCrée un tableau avec tous les éléments faux supprimés (false, null, 0, '', undefined, NaN).",
  },
  {
    value: "flatten",
    label: "flatten",
    description:
      "_.flatten(array)\nAplati un niveau de profondeur d'un tableau.",
  },
  {
    value: "flattenDeep",
    label: "flattenDeep",
    description:
      "_.flattenDeep(array)\nAplati un tableau de manière récursive.",
  },
  {
    value: "uniq",
    label: "uniq",
    description:
      "_.uniq(array)\nCrée un tableau unique des éléments de la collection.",
  },
  {
    value: "uniqBy",
    label: "uniqBy",
    description:
      "_.uniqBy(array, [iteratee=_.identity])\nCrée un tableau unique des éléments de la collection en utilisant un itérateur pour déterminer l'unicité.",
  },
  {
    value: "pluck",
    label: "pluck",
    description:
      "_.map(collection, property)\nMappe une propriété spécifique de chaque élément dans une collection.",
  },
  {
    value: "pick",
    label: "pick",
    description:
      "_.pick(object, [paths])\nCrée un objet composé des propriétés sélectionnées de l'objet source.",
  },
  {
    value: "omit",
    label: "omit",
    description:
      "_.omit(object, [paths])\nCrée un objet en omettant les propriétés spécifiées de l'objet source.",
  },
  {
    value: "merge",
    label: "merge",
    description:
      "_.merge(object, [sources])\nFusionne les propriétés des objets sources dans l'objet destination de manière récursive.",
  },
  {
    value: "defaults",
    label: "defaults",
    description:
      "_.defaults(object, [sources])\nAssigne les valeurs par défaut aux propriétés manquantes de l'objet.",
  },
  {
    value: "clone",
    label: "clone",
    description: "_.clone(value)\nCrée une copie superficielle de la valeur.",
  },
  {
    value: "cloneDeep",
    label: "cloneDeep",
    description: "_.cloneDeep(value)\nCrée une copie profonde de la valeur.",
  },
  {
    value: "sortBy",
    label: "sortBy",
    description:
      "_.sortBy(collection, [iteratees=[_.identity]])\nTrie la collection en fonction des itérateurs spécifiés.",
  },
  {
    value: "orderBy",
    label: "orderBy",
    description:
      "_.orderBy(collection, [iteratees=[_.identity]], [orders])\nTrie la collection en fonction des itérateurs et des ordres spécifiés.",
  },
  {
    value: "groupBy",
    label: "groupBy",
    description:
      "_.groupBy(collection, [iteratee=_.identity])\nGroupe les éléments de la collection par la clé retournée par l'itérateur.",
  },
  {
    value: "countBy",
    label: "countBy",
    description:
      "_.countBy(collection, [iteratee=_.identity])\nCompte les éléments de la collection par la clé retournée par l'itérateur.",
  },
  {
    value: "intersection",
    label: "intersection",
    description:
      "_.intersection([arrays])\nCrée un tableau des éléments communs à tous les tableaux d'entrée.",
  },
  {
    value: "difference",
    label: "difference",
    description:
      "_.difference(array, [values])\nCrée un tableau des éléments présents dans le premier tableau mais pas dans les autres.",
  },
  {
    value: "findIndex",
    label: "findIndex",
    description:
      "_.findIndex(array, [predicate=_.identity], [fromIndex=0])\nTrouve l'index du premier élément qui satisfait le prédicat.",
  },
  {
    value: "includes",
    label: "includes",
    description:
      "_.includes(collection, value, [fromIndex=0])\nVérifie si la valeur est présente dans la collection.",
  },
  {
    value: "every",
    label: "every",
    description:
      "_.every(collection, [predicate=_.identity])\nVérifie si tous les éléments de la collection satisfont le prédicat.",
  },
  {
    value: "some",
    label: "some",
    description:
      "_.some(collection, [predicate=_.identity])\nVérifie si au moins un élément de la collection satisfait le prédicat.",
  },
  {
    value: "isEmpty",
    label: "isEmpty",
    description: "_.isEmpty(value)\nVérifie si la valeur est vide.",
  },
  {
    value: "isEqual",
    label: "isEqual",
    description:
      "_.isEqual(value, other)\nVérifie si deux valeurs sont équivalentes.",
  },
  {
    value: "has",
    label: "has",
    description:
      "_.has(object, path)\nVérifie si la propriété spécifiée existe dans l'objet.",
  },
  {
    value: "capitalize",
    label: "capitalize",
    description:
      "_.capitalize([string=''])\nCapitalise la première lettre d'une chaîne.",
  },
  {
    value: "deburr",
    label: "deburr",
    description:
      "_.deburr([string=''])\nEnlève les accents et diacritiques d'une chaîne.",
  },
  {
    value: "findLast",
    label: "findLast",
    description:
      "_.findLast(collection, [predicate=_.identity], [fromIndex=collection.length-1])\nTrouve le dernier élément dans la collection qui satisfait le prédicat.",
  },
  {
    value: "filter",
    label: "filter",
    description:
      "_.filter(collection, [predicate=_.identity])\nFiltre les éléments de la collection qui satisfont le prédicat.",
  },
  {
    value: "uniq",
    label: "uniq",
    description:
      "_.uniq(array)\nCrée un tableau unique des éléments de la collection.",
  },
  {
    value: "uniqBy",
    label: "uniqBy",
    description:
      "_.uniqBy(array, [iteratee=_.identity])\nCrée un tableau unique des éléments de la collection en utilisant un itérateur pour déterminer l'unicité.",
  },
  {
    value: "remove",
    label: "remove",
    description:
      "_.remove(array, [predicate=_.identity])\nSupprime les éléments de l'array qui satisfont le prédicat et les retourne.",
  },
  {
    value: "reject",
    label: "reject",
    description:
      "_.reject(collection, [predicate=_.identity])\nCrée un tableau des éléments de la collection qui ne satisfont pas le prédicat.",
  },
  {
    value: "compact",
    label: "compact",
    description:
      "_.compact(array)\nCrée un tableau avec tous les éléments faux supprimés (false, null, 0, '', undefined, NaN).",
  },
  {
    value: "drop",
    label: "drop",
    description:
      "_.drop(array, [n=1])\nCrée un tableau sans les n premiers éléments.",
  },
  {
    value: "dropRight",
    label: "dropRight",
    description:
      "_.dropRight(array, [n=1])\nCrée un tableau sans les n derniers éléments.",
  },
  {
    value: "dropWhile",
    label: "dropWhile",
    description:
      "_.dropWhile(array, [predicate=_.identity])\nCrée un tableau sans les éléments initiaux qui satisfont le prédicat.",
  },
  {
    value: "take",
    label: "take",
    description:
      "_.take(array, [n=1])\nCrée un tableau avec les n premiers éléments.",
  },
  {
    value: "takeRight",
    label: "takeRight",
    description:
      "_.takeRight(array, [n=1])\nCrée un tableau avec les n derniers éléments.",
  },
  {
    value: "takeWhile",
    label: "takeWhile",
    description:
      "_.takeWhile(array, [predicate=_.identity])\nCrée un tableau avec les éléments initiaux qui satisfont le prédicat.",
  },
  {
    value: "every",
    label: "every",
    description:
      "_.every(collection, [predicate=_.identity])\nVérifie si tous les éléments de la collection satisfont le prédicat.",
  },
  {
    value: "some",
    label: "some",
    description:
      "_.some(collection, [predicate=_.identity])\nVérifie si au moins un élément de la collection satisfait le prédicat.",
  },
  {
    value: "compact",
    label: "compact",
    description:
      "_.compact(array)\nCrée un tableau avec tous les éléments faux supprimés (false, null, 0, '', undefined, NaN).",
  },
  {
    value: "orderBy",
    label: "orderBy",
    description:
      "_.orderBy(collection, [iteratees=[_.identity]], [orders])\nTrie la collection en fonction des itérateurs et des ordres spécifiés.",
  },
  {
    value: "slice",
    label: "slice",
    description:
      "_.slice(array, [start=0], [end=array.length])\nCrée un tableau avec les éléments de l'array compris entre les indices start et end.",
  },
  {
    value: "without",
    label: "without",
    description:
      "_.without(array, [values])\nCrée un tableau sans les valeurs spécifiées.",
  },
  {
    value: "words",
    label: "words",
    description:
      "_.words(string, [pattern])\nDivise une chaîne en un tableau de mots en utilisant un motif.",
  },
  {
    value: "getMultiple",
    label: "getMultiple",
    description:
      "_.getMultiple(object, paths)\nRécupère plusieurs valeurs à partir des chemins spécifiés et les place dans un tableau. Les chemins non trouvés sont ignorés.",
  },

  {
    value: "findWithRegex",
    label: "findWithRegex",
    description:
      "_.findWithRegex(regex, key)\nTrouve le premier élément dans la collection qui satisfait le prédicat.",
  },

  {
    value: "filterWithRegex",
    label: "filterWithRegex",
    description:
      "_.filterWithRegex(regex, key)\nFiltre les éléments de la collection qui satisfont le prédicat.",
  },

  // Ajoutez d'autres fonctions Lodash utiles pour le parsing ici
].map((fn, index) => ({ ...fn, id: `${fn.value}_${index}` }));
